// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"411":"0f12386dc9ea3037","521":"b766ef233d6cc968","964":"d602607b7a7a70bc"}[chunkId] + ".js";
};